/* global localData */
const steps = document.querySelectorAll('div.steps-process');
const loading = document.querySelector('.site-loader');
const orderPerks = ['input[name="delivery"]', 'input[name="delivery-type"]', '#is_gift', 'input[name="gift_ticket"]'];

const hideProcessButtonForNonSL = () => {
  setTimeout(() => {
    let isValidToPay = getUserAddressCode() === 'SI';
    if (!isValidToPay) {
      isValidToPay = localData.cart.price <= localData.cart.shipping_limit;
    }
    if (document.querySelector('#on_company').checked) {
      isValidToPay = false;
    }
    document.querySelector('#sc-purchase-process-info-02 .btn--tertiary').hidden = !isValidToPay;
    document.querySelector('.btn-send-draft').closest('.btn-normal').hidden = isValidToPay;
  }, 150);
};
const addClassAndValue = (selector, value) => {
  const addressInput = document.querySelector(selector);
  addressInput.closest('.mod-input').classList.add('is-focused');
  addressInput.value = value;
};
const fillInputsGooglePlaces = (addressComponents, suffix = '') => {
  const { route, country, country_long, street_number, postal_code, postal_town, locality } = addressComponents;
  let countryDropdown = document.querySelector('[name="state_extra"]');
  if (suffix !== '_extra') {
    countryDropdown = document.querySelector(`[name="country${suffix ? '_2' : '_1'}"]`);
    if (countryDropdown) {
      const dropdown = countryDropdown.closest('.dropdown');
      const selectedCountry = dropdown.querySelector(`[data-type="${country}"]`);
      if (selectedCountry) {
        dropdown.querySelector('.dropdown__placeholder-text').innerHTML = selectedCountry.dataset.title;
        selectedCountry.click();
        dropdown.classList.add('is-selected');
      }
    }
    addClassAndValue(`[name="address${suffix}"]`, `${route} ${street_number}`);
    addClassAndValue(`[name="post${suffix}"]`, postal_code);
  } else {
    countryDropdown.closest('.mod-input').classList.add('is-focused');
    countryDropdown.value = country_long;
    addClassAndValue(`[name="address_1${suffix}"]`, `${route} ${street_number}`);
    addClassAndValue(`[name="postcode${suffix}"]`, postal_code);
  }
  addClassAndValue(`[name="city${suffix}"]`, postal_town || locality);
  resetShippingDropVariant();
};
const initializeGooglePlacesSearch = () => {
  const inputIds = ['#address', '#address_diff', '#address_1_extra'];
  inputIds.forEach((inputId) => {
    const input = document.querySelector(inputId);
    if (input) {
      const options = {};
      options.componentRestrictions = {};
      const autocomplete = new google.maps.places.Autocomplete(input, options);
      google.maps.event.addListener(autocomplete, 'place_changed', () => {
        const addressComponents = {
          postal_code: '',
          street_number: '',
          country: '',
          country_long: '',
          route: '',
          postal_town: '',
          locality: '',
        };
        const place = autocomplete.getPlace();
        place.address_components.forEach((component) => {
          const [type] = component.types;
          if (addressComponents[type] !== undefined) {
            addressComponents[type] = type === 'country' ? component.short_name : component.long_name;
            if (type === 'country') {
              addressComponents.country_long = component.long_name;
            }
          }
        });
        if (addressComponents.street_number === '') {
          const inputValueParts = input.value.split(',');
          addressComponents.route = inputValueParts.length > 0 ? inputValueParts[0] : input.value;
        }
        fillInputsGooglePlaces(
          addressComponents,
          input.id === 'address_1_extra' ? '_extra' : input.id === 'address' ? '' : '_diff',
        );
        hideProcessButtonForNonSL();
      });
    }
  });
};
const hideSidebar = () => {
  const processSidebar = document.querySelector('.purchase-process-sidebar');
  if (processSidebar && window.innerWidth < 1023) {
    const content = processSidebar.querySelector('.purchase-process-sidebar__content');
    slideUp(content, 300);
    processSidebar.classList.remove('is-open');
  }
};
const hideAllSteps = () => {
  steps.forEach((item) => {
    item.hidden = true;
  });
};
const showStep = (step) => {
  steps.forEach((item) => {
    if (item.classList.contains(step)) {
      item.hidden = false;
    }
  });
};
const getActiveStep = () => {
  let active = 0;
  steps.forEach((item) => {
    if (item.hidden === false) {
      const [result] = item.id.match(/\d+/);
      active = result;
    }
  });
  return active;
};

const getInputData = () => {
  const formData = {};
  // eslint-disable-next-line consistent-return
  const getInputDataIn = (input) => {
    if (input.type === 'radio' && input.closest('.add-child__col') && input.checked) {
      return input.dataset.type;
    }
    if (input.type !== 'checkbox' && input.type !== 'radio') {
      return input.value.trim();
    }
    if (input.checked) {
      return input.dataset.title || input.id.trim();
    }
  };
  document.querySelectorAll('input, textarea, select').forEach((input) => {
    const getValue = getInputDataIn(input);
    if (getValue !== undefined && getValue !== '' && getValue !== 'on' && input.name) {
      formData[input.name] = getValue;
    }
  });
  formData.shipping_country_code = getUserAddressCode();
  return formData;
};

let stripe;
let elements;
if (document.querySelector('.sc-purchase-process-info-03') && typeof localData === 'object') {
  stripe = Stripe(localData.stripeKey, {
    locale: localData.lang,
  });
}

const initializeStripe = () => {
  document.querySelector('#payment-element').innerHTML = '';
  const axiosData = new FormData();
  axiosData.append('action', 'createStripeClientKey');
  axiosData.append('inputs', JSON.stringify(getInputData()));
  axiosData.append('user_code', getUserAddressCode());
  axios
    .post(localData.apiURL, axiosData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
      if (response.status === 200) {
        localData.clientSecret = response.data.clientSecret;
        elements = stripe.elements({ clientSecret: response.data.clientSecret });
        const paymentElement = elements.create('payment');
        paymentElement.mount('#payment-element');
      }
    });
};

const showMessage = (messageText) => {
  const messageContainer = document.querySelector('#payment-message');
  messageContainer.hidden = false;
  messageContainer.innerHTML = messageText;
};

const getSelectedPaymentMethod = () => {
  const selectedMethod = Array.from(document.querySelectorAll('input[name="payment-methods"]')).find(
    (item) => item.checked,
  );
  return selectedMethod ? selectedMethod.id : '';
};

async function handleSubmitStripe(token) {
  const { paymentIntent } = await stripe.retrievePaymentIntent(localData.clientSecret);
  const axiosData = new FormData();
  axiosData.append('action', 'createOrderFromCartItems');
  axiosData.append('type', 'stripe');
  axiosData.append('token', token);
  axiosData.append('stripePaymentIntentId', paymentIntent.id);
  axiosData.append('stripePaymentIntentSecret', paymentIntent.client_secret);
  axiosData.append('inputs', JSON.stringify(getInputData()));
  await axios.post(localData.apiURL, axiosData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  const { error } = await stripe.confirmPayment({
    elements,
    confirmParams: {
      return_url: `${localData.apiURL}?action=updateOrderStatus`,
    },
  });
  setTimeout(() => {
    toggleLoaderClass(loading, false);
  }, 2000);
  if (error.type === 'card_error' || error.type === 'validation_error' || error.type === 'invalid_request_error') {
    const axiosDataFail = new FormData();
    axiosDataFail.append('action', 'updateOrderStatus');
    axiosDataFail.append('type', 'stripe');
    axiosDataFail.append('status', 'failed');
    axiosDataFail.append('code', error.code);
    axiosDataFail.append('decline_code', error.decline_code);
    axiosDataFail.append('stripePaymentIntentId', paymentIntent.id);
    axiosDataFail.append('stripePaymentIntentSecret', paymentIntent.client_secret);
    axios.post(localData.apiURL, axiosDataFail, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    showMessage(localData.translations.payment_error);
  } else {
    showMessage('An unexpected error occurred.');
  }
}

const handleSubmitMoney = (token, type) => {
  const axiosData = new FormData();
  axiosData.append('action', 'createOrderFromCartItems');
  axiosData.append('type', type === 'cash-money' ? 'money' : type);
  axiosData.append('token', token);
  axiosData.append('inputs', JSON.stringify(getInputData()));
  axios
    .post(localData.apiURL, axiosData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
      window.location.href = response.data.data.url;
      setTimeout(() => {
        toggleLoaderClass(loading, false);
      }, 2000);
    });
};

const reInitPayMethods = () => {
  document.querySelectorAll('input[name="payment-methods"]:checked').forEach((item) => {
    if (item.id === 'credit-card') {
      initializeStripe();
    }
  });
};

const changeSidBarPrice = (data) => {
  const axiosData = new FormData();
  axiosData.append('action', 'getSidePriceHtml');
  axiosData.append('data', JSON.stringify(data));
  axios
    .post(localData.apiURL, axiosData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
      document.querySelector('.purchase-process-prices').innerHTML = response.data.data;
      if (
        response.data.amount &&
        document.querySelector('.purchase-process-sidebar__header-price') &&
        response.data.amount.final.text__right
      ) {
        document.querySelector('.purchase-process-sidebar__header-price').innerHTML =
          response.data.amount.final.text__right;
      }
    });
};

const sendPerksData = () => {
  const perks = getCheckedPerks();
  const axiosData = new FormData();
  axiosData.append('action', 'addPerksToCart');
  axiosData.append('perks', JSON.stringify(perks));
  axiosData.append('user_code', getUserAddressCode());
  axios
    .post(localData.apiURL, axiosData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
      const selectedDelivery = document.querySelector('#sc-purchase-process-info-02 input[name="delivery"]:checked');
      if (response.data.delivery.shipping_price && selectedDelivery) {
        selectedDelivery
          .closest('.purchase-process-dropdown__item')
          .querySelector('.purchase-process-dropdown__item-price').innerHTML = response.data.delivery.shipping_price;
      }
      changeSidBarPrice(response.data);
      reInitPayMethods();
    });
};

const createAddressValidator = () => ({
  validators: {
    regexp: {
      regexp: /.*\d/,
      message: localData.translations.address_warning,
    },
  },
});

const eventHandleCheckoutForm = (form) => {
  const emailError = getEmailError(form);

  const fv = FormValidation.formValidation(form, {
    locale: 'sl_SI',
    localization: FormValidation.locales.sl_SI,
    fields: {
      'delivery-type': {
        validators: {
          notEmpty: {
            message: localData.translations.delivery_warning,
          },
        },
      },
      'payment-methods': {
        validators: {
          notEmpty: {
            message: localData.translations.payment_warning,
          },
        },
      },
      privacy: {
        validators: {
          notEmpty: {
            message: localData.translations.privacy_warning,
          },
        },
      },
      contact_mail: {
        validators: {
          regexp: {
            regexp: '^[^@\\s]+@([^@\\s]+\\.)+[^@\\s]+$',
            message: emailError,
          },
        },
      },
      address: createAddressValidator(),
      address_diff: createAddressValidator(),
      address_1_extra: createAddressValidator(),
    },
    plugins: {
      message: new FormValidation.plugins.Message({
        container: (field, element) => {
          const parentElement = element.closest(
            '.mod-input, .purchase-process-dropdowns__item-dropdowns, .checkbox[data-component="at-checkbox"]',
          );
          return parentElement || element;
        },
      }),
      declarative: new FormValidation.plugins.Declarative({
        html5Input: true,
      }),
      trigger: new FormValidation.plugins.Trigger({
        event: 'submit',
      }),
      excluded: new FormValidation.plugins.Excluded(),
      submitButton: new FormValidation.plugins.SubmitButton({
        // eslint-disable-next-line no-shadow
        buttons(form) {
          const stepForm = form.closest('.steps-process');
          return [].slice.call(
            stepForm.querySelectorAll(
              '.btn-send-draft, button.btn--tertiary, .breadcrumbs__link[data-action], .purchase-process__address-contact__change, .edit-address-form__submit button',
            ),
          );
        },
      }),
    },
  }).on('core.element.validated', (e) => {
    // e.element presents the field element
    // e.valid indicates the field is valid or not
    if (e.element.hasAttribute('required')) {
      // Get the field value
      const value = fv.getElementValue(e.field, e.element);
      const container = FormValidation.utils.closest(
        e.element,
        '.mod-input,.purchase-process-dropdowns__item-dropdowns,.checkbox[data-component="at-checkbox"],.dropdown[data-component="at-dropdown"]',
      );
      FormValidation.utils.classSet(container, {
        'is-validation-failed': value.trim() === '' || !e.valid,
      });
    }
  });
};

const getUserAddress = () => {
  if (document.querySelector('#different_address').checked) {
    const formDifferentAddress = document
      .querySelector('#different_address')
      .closest('.purchase-process-form__checkbox-dropdowns');
    return `${formDifferentAddress.querySelector('#address_diff').value} ${
      formDifferentAddress.querySelector('#post_diff').value
    } ${formDifferentAddress.querySelector('#city_diff').value}`;
  }
  if (document.querySelector('.purchase-process-form__addresses-main')) {
    return document.querySelector('.purchase-process-form__addresses__right').innerHTML;
  }
  const formAddress = document.querySelector('.sc-purchase-process-info-01');
  return `${formAddress.querySelector('#address').value} ${formAddress.querySelector('#post').value} ${
    formAddress.querySelector('#city').value
  }`;
};

const getUserAddressCode = () => {
  if (document.querySelector('#different_address').checked && document.querySelector('[name="country_2"]:checked')) {
    return document.querySelector('[name="country_2"]:checked').dataset.type;
  }
  if (document.querySelector('[name="country_1"]:checked')) {
    return document.querySelector('[name="country_1"]:checked').dataset.type;
  }
  return 'SI';
};

const saveContactInfoToCookie = () => {
  if (document.querySelector('#save_for_next_time').checked) {
    const inputValues = {};
    const inputs = document.querySelectorAll('#contact_email, .purchase-process-form__inputs input');
    inputs.forEach((input) => {
      if (input.type === 'text' || input.type === 'email') {
        inputValues[input.id] = input.value;
      } else if (input.type === 'radio' && input.checked) {
        inputValues[input.name] = input.dataset.type;
      }
    });
    Cookies.set('users_data', JSON.stringify(inputValues), true, { expires: 31 });
  } else {
    document.cookie = 'users_data=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  }
};

const fillUserDataFromCookie = () => {
  const cookie = Cookies.get('users_data');
  if (cookie) {
    const jsonData = JSON.parse(cookie);
    const inputs = document.querySelectorAll('#contact_email, .purchase-process-form__inputs input');
    inputs.forEach((input) => {
      if (input.type === 'radio' && jsonData.country_1 === input.dataset.type) {
        const dropdown = input.closest('.dropdown');
        const selectedCountry = dropdown.querySelector(`[data-type="${jsonData.country_1}"]`);
        if (selectedCountry) {
          dropdown.querySelector('.dropdown__placeholder-text').innerHTML = selectedCountry.dataset.title;
          selectedCountry.click();
          dropdown.classList.add('is-selected');
        }
      } else if ((input.type === 'text' || input.type === 'email') && input.closest('.mod-input')) {
        input.closest('.mod-input').classList.add('is-focused');
        input.value = jsonData[input.id];
      } else if (input.name === 'save_for_next_time') {
        input.checked = true;
      }
    });
    hideProcessButtonForNonSL();
  }
};

const changeDynamicUserData = (goToStep) => {
  const userDelivery = document.querySelector('[name="delivery"]:checked');
  steps.forEach((item) => {
    if (item.querySelector('.mail-contact')) {
      item.querySelector('.mail-contact').innerHTML = document.querySelector('#contact_email').value;
    }
    if (item.querySelector('.address-contact')) {
      item.querySelector('.address-contact').innerHTML = getUserAddress();
    }
    if (item.querySelector('.delivery-contact') && userDelivery) {
      item.querySelector('.delivery-contact').innerHTML = userDelivery
        .closest('.purchase-process-dropdown__item')
        .querySelector('.purchase-process-dropdown__item-title').innerText;
    }
  });
  if (goToStep === 'sc-purchase-process-info-02' && document.querySelector('#save_for_next_time')) {
    saveContactInfoToCookie();
  }
  const stepNumber = parseInt(goToStep.split('-').pop(), 10);
  document.querySelectorAll('.purchase-process__indicator-icon').forEach((el, index) => {
    el.classList.remove('is-active', 'is-done');
    if (index + 1 < stepNumber) {
      el.classList.add('is-done');
    } else if (index + 1 === stepNumber) {
      el.classList.add('is-active');
    }
  });
};

const resetShippingDropVariant = () => {
  const allShipping = document.querySelectorAll('.purchase-process-dropdown input[name="delivery"][data-code]');
  const deliveryTypeCheckbox = document.querySelector('#delivery-type');
  const dropdownDrop = deliveryTypeCheckbox
    .closest('.purchase-process-dropdown')
    .querySelector('.purchase-process-dropdown__drop');

  const userCode = getUserAddressCode();
  if (userCode) {
    allShipping.forEach((i) => {
      const closestItem = i.closest('.purchase-process-dropdown__item');
      closestItem.hidden = !(
        i.dataset.code.includes(`|${userCode}|`) ||
        (userCode !== 'HR' && userCode !== 'SI' && i.dataset.code === 'OTHER')
      );
      i.checked = false;
    });
    let allHidden = true;
    allShipping.forEach((i) => {
      const closestItem = i.closest('.purchase-process-dropdown__item');
      if (!closestItem.hidden) {
        allHidden = false;
      }
    });
    if (allHidden) {
      allShipping.forEach((i) => {
        const closestItem = i.closest('.purchase-process-dropdown__item');
        closestItem.hidden = i.dataset.code !== '||';
      });
    }
    dropdownDrop.setAttribute('style', 'box-sizing: border-box; display: none;');
    deliveryTypeCheckbox.checked = false;
  }
};

const getCheckedPerks = () => {
  const perks = {};
  orderPerks.forEach((item) => {
    const checkbox = document.querySelectorAll(item);
    checkbox.forEach((ch) => {
      if (ch.checked) {
        perks[ch.name] = ch.dataset.title || ch.id;
      }
    });
  });
  return perks;
};

document.addEventListener('DOMContentLoaded', () => {
  if (!document.querySelector('.sc-purchase-process-info-01')) {
    return;
  }
  window.addEventListener('pageshow', (event) => {
    const navigationEntries = performance.getEntriesByType('navigation');
    if (
      event.persisted ||
      (window.performance && navigationEntries.length > 0 && navigationEntries[0].type === 'back_forward')
    ) {
      window.location.reload();
    }
  });
  document.querySelectorAll('input[name="country_1"], input[name="country_2"]').forEach((item) => {
    item.addEventListener('change', resetShippingDropVariant);
  });
  document.querySelectorAll('.saved-address').forEach((ch) => {
    ch.addEventListener('click', resetShippingDropVariant);
  });
  ['sc-purchase-process-info-01', 'sc-purchase-process-info-02', 'sc-purchase-process-info-03'].forEach((id) => {
    const form = document.querySelector(`#${id}`);
    if (form !== null) {
      eventHandleCheckoutForm(form.querySelector('form'));
    }
  });
  orderPerks.forEach((checkers) => {
    const checkboxes = document.querySelectorAll(checkers);
    checkboxes.forEach((item) => {
      item.addEventListener('click', () => {
        if (item.name === 'gift_ticket' && item.checked) {
          document.querySelectorAll('input[name="gift_ticket"]').forEach((ticket) => {
            if (ticket !== item) {
              ticket.checked = false;
            }
          });
        }
        setTimeout(() => {
          sendPerksData();
        }, 200);
      });
    });
  });
  document
    .querySelectorAll('a[data-action]:not(.login--checkout), button[data-action]:not(.login--checkout)')
    .forEach((el) => {
      el.addEventListener('click', (e) => {
        const stepWantToGo = Number(e.target.dataset.action.match(/\d+/)[0]);
        const activeStep = Number(getActiveStep());
        let goToStep = e.target.dataset.action;
        if (!e.target.closest('.steps-process').querySelector('.is-validation-failed') || stepWantToGo <= activeStep) {
          if (stepWantToGo === 3 && activeStep === 1 && !document.querySelector('#delivery-type').checked) {
            // prevent to skip second step from first one
            goToStep = 'sc-purchase-process-info-02';
          }
          // Card payment is only available for Slovenian individual customers.
          if (goToStep === 'sc-purchase-process-info-03') {
            const creditCardCheck = document.querySelector('#credit-card');
            if (creditCardCheck) {
              creditCardCheck.closest('.purchase-process-dropdown').hidden =
                document.querySelector('#on_company').checked;
              creditCardCheck.checked = false;
            }
          }
          if (goToStep === 'sc-purchase-process-info-02') {
            const warning = document.querySelector('.shipping-warning');
            if (warning) {
              warning.hidden = getUserAddressCode() === 'SI';
            }
          }
          const newAddressContainer = document.querySelector('.new-address');
          if (
            activeStep === 1 &&
            newAddressContainer &&
            newAddressContainer.classList.contains('is-active') &&
            document.querySelector('#address_1_extra').value
          ) {
            // prevent to go to second step if "add new address" form is open with all inputs inside
            document
              .querySelector('.purchase-process-form__addresses')
              .scrollIntoView({ behavior: 'smooth', block: 'start' });
            return;
          }
          changeDynamicUserData(goToStep);
          hideSidebar();
          hideAllSteps();
          showStep(goToStep);
          document.querySelector('main').scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        if (document.querySelector('.is-validation-failed')) {
          document.querySelector('.is-validation-failed').scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    });
  document.querySelectorAll('#credit-card').forEach((item) => {
    item.addEventListener('click', () => {
      sendPerksData();
    });
  });
  document.querySelectorAll('#sc-purchase-process-info-01 .dropdown__list-item input').forEach((item) => {
    item.addEventListener('click', () => {
      hideProcessButtonForNonSL();
    });
  });
  document.querySelectorAll('.sc-purchase-process-info-03 button[type="submit"], .btn-send-draft').forEach((item) => {
    item.addEventListener('click', (ev) => {
      if (!ev.target.closest('.purchase-process-form').querySelector('.is-validation-failed')) {
        ev.preventDefault();
        const paymentMethod = getSelectedPaymentMethod();
        grecaptcha.ready(() => {
          if (!document.querySelector('.site-loader.is-loading')) {
            toggleLoaderClass(loading, true);
            document.querySelector('#payment-message').hidden = true;
            grecaptcha.execute(localData.captchaSiteKey, { action: 'createOrderFromCartItems' }).then((token) => {
              if (paymentMethod === 'credit-card') {
                handleSubmitStripe(token);
              } else if (paymentMethod === 'invoice') {
                handleSubmitMoney(token, paymentMethod);
              } else if (item.classList.contains('btn-send-draft')) {
                handleSubmitMoney(token, 'draft');
              }
            });
          }
        });
      }
    });
  });
  window.addEventListener('load', () => {
    initializeGooglePlacesSearch();
    resetShippingDropVariant();
    fillUserDataFromCookie();
    // prevent showing process button for non-SL users
    attachEvent('#different_address', 'click', () => {
      hideProcessButtonForNonSL();
    });
    attachEvent('#on_company', 'click', () => {
      hideProcessButtonForNonSL();
      resetShippingDropVariant();
    });
  });
});
